import { render, staticRenderFns } from "./SelectTiposInstituicoes.vue?vue&type=template&id=73ba1f6e"
import script from "./SelectTiposInstituicoes.vue?vue&type=script&lang=js"
export * from "./SelectTiposInstituicoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports